import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

/**
 * A quiet single-column editorial statement on warm ivory —
 * the "philosophy" beat after the cinematic hero.
 */
export default function ServicePhilosophy() {
  return (
    <section
      data-testid="service-philosophy-section"
      className="bg-ivory py-28 md:py-40"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <motion.p
          {...fadeUp}
          className="sjc-eyebrow text-muted-light flex items-center justify-center gap-4"
        >
          <span className="sjc-hairline w-8" />
          The Philosophy
          <span className="sjc-hairline w-8" />
        </motion.p>

        <motion.h2
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.1 }}
          className="font-display mt-10 text-charcoal text-3xl md:text-4xl lg:text-[46px] leading-[1.2] tracking-[-0.015em]"
        >
          A quiet standard of travel,
          <br className="hidden md:block" />
          <span className="italic font-light"> considered in every detail.</span>
        </motion.h2>

        <motion.p
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.2 }}
          className="mt-10 text-muted-light text-base md:text-lg leading-[1.85] font-light"
        >
          Sydney James is a private chauffeur service built for those who value discretion,
          precision and calm. Our chauffeurs are seasoned professionals — Sydney locals who
          know the city&apos;s rhythms, its shortcuts and its silences. Every journey is
          treated as its own occasion.
        </motion.p>
      </div>
    </section>
  );
}
